import { Tab, TabGroup, TabList, TabPanel, TabPanels } from '@headlessui/react'
import classNames from 'classnames'
import { ReactNode } from 'react'

type TabsProps = {
  flipped?: boolean
  panels: TabPanelConfig[]
}

type TabPanelConfig = {
  id: string
  label: ReactNode
  content?: ReactNode
  href?: string
  onClick?: () => void
}

export function Tabs({ flipped, panels }: TabsProps) {
  return (
    <TabGroup
      as='div'
      className='flex flex-col items-start justify-start w-full'
    >
      <TabList
        className={classNames(
          'flex items-center justify-start py-1.5 space-x-2 max-w-full overflow-x-auto',
          flipped ? 'order-2' : 'order-1'
        )}
      >
        {panels.map((panel) => (
          <Tab
            as='a'
            type='button'
            className='transition duration-300 ease-out rounded-md outline-none bg-inherit shrink-0'
            key={panel.id}
            href={panel.href}
            onClick={panel.onClick}
          >
            {panel.label}
          </Tab>
        ))}
      </TabList>
      <TabPanels
        className={classNames('py-1.5', flipped ? 'order-1' : 'order-2')}
      >
        {panels.map((panel) => (
          <TabPanel
            as='div'
            key={panel.id}
            className='w-full opacity-0 data-[selected]:!opacity-100'
          >
            {panel.content}
          </TabPanel>
        ))}
      </TabPanels>
    </TabGroup>
  )
}
